module.exports = __webpack_public_path__ + "img/barcode.8bef1716.png";